/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BaseCompanyDetailsViewModel } from './BaseCompanyDetailsViewModel';
import {
    BaseCompanyDetailsViewModelFromJSON,
    BaseCompanyDetailsViewModelFromJSONTyped,
    BaseCompanyDetailsViewModelToJSON,
} from './BaseCompanyDetailsViewModel';
import type { BaseIndividualDetailsViewModel } from './BaseIndividualDetailsViewModel';
import {
    BaseIndividualDetailsViewModelFromJSON,
    BaseIndividualDetailsViewModelFromJSONTyped,
    BaseIndividualDetailsViewModelToJSON,
} from './BaseIndividualDetailsViewModel';
import type { BaseNonTaxableInstitutionViewModel } from './BaseNonTaxableInstitutionViewModel';
import {
    BaseNonTaxableInstitutionViewModelFromJSON,
    BaseNonTaxableInstitutionViewModelFromJSONTyped,
    BaseNonTaxableInstitutionViewModelToJSON,
} from './BaseNonTaxableInstitutionViewModel';
import type { BaseTrustDetailsViewModel } from './BaseTrustDetailsViewModel';
import {
    BaseTrustDetailsViewModelFromJSON,
    BaseTrustDetailsViewModelFromJSONTyped,
    BaseTrustDetailsViewModelToJSON,
} from './BaseTrustDetailsViewModel';
import type { IAPPARTYTYPE } from './IAPPARTYTYPE';
import {
    IAPPARTYTYPEFromJSON,
    IAPPARTYTYPEFromJSONTyped,
    IAPPARTYTYPEToJSON,
} from './IAPPARTYTYPE';

/**
 * 
 * @export
 * @interface BasePartyViewModel
 */
export interface BasePartyViewModel {
    /**
     * 
     * @type {number}
     * @memberof BasePartyViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {number}
     * @memberof BasePartyViewModel
     */
    externalPartyId?: number;
    /**
     * 
     * @type {IAPPARTYTYPE}
     * @memberof BasePartyViewModel
     */
    partyType: IAPPARTYTYPE;
    /**
     * 
     * @type {boolean}
     * @memberof BasePartyViewModel
     */
    isIssued?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BasePartyViewModel
     */
    issuedOrProspectiveDisplayName?: string;
    /**
     * 
     * @type {BaseIndividualDetailsViewModel}
     * @memberof BasePartyViewModel
     */
    individual?: BaseIndividualDetailsViewModel;
    /**
     * 
     * @type {BaseTrustDetailsViewModel}
     * @memberof BasePartyViewModel
     */
    trust?: BaseTrustDetailsViewModel;
    /**
     * 
     * @type {BaseCompanyDetailsViewModel}
     * @memberof BasePartyViewModel
     */
    company?: BaseCompanyDetailsViewModel;
    /**
     * 
     * @type {BaseNonTaxableInstitutionViewModel}
     * @memberof BasePartyViewModel
     */
    nonTaxableInstitution?: BaseNonTaxableInstitutionViewModel;
}

/**
 * Check if a given object implements the BasePartyViewModel interface.
 */
export function instanceOfBasePartyViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partyType" in value;

    return isInstance;
}

export function BasePartyViewModelFromJSON(json: any): BasePartyViewModel {
    return BasePartyViewModelFromJSONTyped(json, false);
}

export function BasePartyViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasePartyViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'externalPartyId': !exists(json, 'ExternalPartyId') ? undefined : json['ExternalPartyId'],
        'partyType': IAPPARTYTYPEFromJSON(json['PartyType']),
        'isIssued': !exists(json, 'IsIssued') ? undefined : json['IsIssued'],
        'issuedOrProspectiveDisplayName': !exists(json, 'IssuedOrProspectiveDisplayName') ? undefined : json['IssuedOrProspectiveDisplayName'],
        'individual': !exists(json, 'Individual') ? undefined : BaseIndividualDetailsViewModelFromJSON(json['Individual']),
        'trust': !exists(json, 'Trust') ? undefined : BaseTrustDetailsViewModelFromJSON(json['Trust']),
        'company': !exists(json, 'Company') ? undefined : BaseCompanyDetailsViewModelFromJSON(json['Company']),
        'nonTaxableInstitution': !exists(json, 'NonTaxableInstitution') ? undefined : BaseNonTaxableInstitutionViewModelFromJSON(json['NonTaxableInstitution']),
    };
}

export function BasePartyViewModelToJSON(value?: BasePartyViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'ExternalPartyId': value.externalPartyId,
        'PartyType': IAPPARTYTYPEToJSON(value.partyType),
        'IsIssued': value.isIssued,
        'IssuedOrProspectiveDisplayName': value.issuedOrProspectiveDisplayName,
        'Individual': BaseIndividualDetailsViewModelToJSON(value.individual),
        'Trust': BaseTrustDetailsViewModelToJSON(value.trust),
        'Company': BaseCompanyDetailsViewModelToJSON(value.company),
        'NonTaxableInstitution': BaseNonTaxableInstitutionViewModelToJSON(value.nonTaxableInstitution),
    };
}

